"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductNavSections = exports.ProductNavSectionsPropTypes = exports.NavigationSections = exports.NavigationSectionPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deprecated = _interopRequireDefault(require("prop-types-extra/lib/deprecated"));

var NavigationSectionPropTypes = _propTypes.default.shape({
  /**
   * The text for the navigation link
   */
  title: _propTypes.default.string,

  /**
   * An action to preform on the click of the navigation item.
   *
   * Note if `subNavSections` is defined, we will open the subNav instead of triggering the onClick
   */
  onClick: _propTypes.default.func,

  /**
   * The url to apply to the button
   */
  href: _propTypes.default.string,

  /**
   * If excluded paths are passed in, the item will not be selected if the url matches the excluded path.
   */
  excludedPaths: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * To determine if the button href should open in a new window.
   */
  openInNewWindow: _propTypes.default.openInNewWindow,

  /**
   * Set to true to hide the section. Good use case for this is conditionally showing routes based on permissions.
   */
  hide: _propTypes.default.bool,

  /**
   * If defined, will open the sub-nav menu and display the sections defined.
   */
  subNavSections: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The text for the sub-nav section
     */
    title: _propTypes.default.string,

    /**
     * Items that go underneath each subnav section
     */
    items: _propTypes.default.shape({
      /**
       * The text for the sub-nav link
       */
      title: _propTypes.default.string,

      /**
       * The action to perform on the click of the link
       */
      onClick: _propTypes.default.func,

      /**
       * The url to apply to the button
       */
      href: _propTypes.default.string,

      /**
       * To determine if the href should be opened in a new window
       */
      openItemInNewWindow: _propTypes.default.openInNewWindow,

      /**
       * This allows us to provide a component that the nav link will render as.
       *
       * Example:
       * React-Router
       * (props) => <Link {...props} to={props.href} />
       */
      component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

      /**
       * Set to true to hide the section. Good use case for this is conditionally showing routes based on permissions.
       */
      hide: _propTypes.default.bool
    })
  })),

  /**
   * A fixed header that will always display in the sub-navigation
   */
  subNavHeader: _propTypes.default.node,

  /**
   * This allows us to provide a component that the nav link will render as.
   *
   * Example:
   * React-Router
   * (props) => <Link {...props} to={props.href} />
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
});

exports.NavigationSectionPropTypes = NavigationSectionPropTypes;

var NavigationSections = _propTypes.default.objectOf(_propTypes.default.shape({
  /**
   * The title of the navigation section
   */
  title: _propTypes.default.string,

  /**
   * The items to display in the navigation section. Please see `navigationSectionItems` for description
   */
  items: _propTypes.default.objectOf(NavigationSectionPropTypes),

  /**
   * Function to set selected attribute of the list item
   */
  selected: _propTypes.default.func
}));

exports.NavigationSections = NavigationSections;

var ProductNavSectionsPropTypes = _propTypes.default.shape({
  /**
   * The text for the navigation link
   */
  title: _propTypes.default.string.isRequired,

  /**
   * An action to preform on the click of the navigation item.
   * Example:
   * React-Router
   * (props) => <Link {...props} to={props.href} />
   */
  onClick: _propTypes.default.func,

  /**
   * The url to apply to the button
   */
  href: _propTypes.default.string,

  /**
   * @deprecated
   * Use onClick instead
   */
  onClickAction: (0, _deprecated.default)(_propTypes.default.func, "Deprecation warning: This Page uses the deprecated `onClickAction` prop. Use `onClick` instead.")
});

exports.ProductNavSectionsPropTypes = ProductNavSectionsPropTypes;

var ProductNavSections = _propTypes.default.arrayOf(ProductNavSectionsPropTypes);

exports.ProductNavSections = ProductNavSections;